module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src4078178155/src/~/core-js/library/modules/_is-object.js
// module id = YmCC
// module chunks = 6